import { BATCH_TABLE_DATA_FAILURE, BATCH_TABLE_DATA_REQUEST, BATCH_TABLE_DATA_SUCCESS, } from "@/redux/actions/Shipment/BatchTableData";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const batchTableDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case BATCH_TABLE_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case BATCH_TABLE_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case BATCH_TABLE_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default batchTableDataReducer;
